export const environment = {
    production: false,
    apiUrl: 'https://api-dev.nonprod.cloud.univa.health/api/v1/',
    baseApiUrl: 'https://api-dev.nonprod.cloud.univa.health/api/',
    sentryDsnAngular: "https://a0216d7e4e59902f35d808905d467ed7@o4508720975642624.ingest.de.sentry.io/4508765652975697",
    envName: 'development'
};
